
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import HomeRedirect from "./pages/HomeRedirect";
import AuthForm from "./components/AuthForm";
import DashboardLayout from "./layouts/DashboardLayout";
import Simulacros from "./pages/Simulacros";
import Diagnostico from "./pages/Diagnostico";
import Resultados from "./pages/Resultados";
import RequireAuth from "./components/RequireAuth";
import PruebaIntro   from "./components/PruebaIntro";
import ExamenRunner  from "./components/ExamenRunner";
import ResultadoSimple from "./pages/ResultadoSimple";


export default function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<HomeRedirect />} />
        <Route path="/login" element={<AuthForm />} />
        <Route path="/app/*" element={<RequireAuth><DashboardLayout /></RequireAuth> }>
          <Route index element={<Diagnostico />} />
          <Route path="simulacros" element={<Simulacros />} />
          <Route path="diagnostico" element={<Diagnostico />} />
          <Route path="pruebas/:id"        element={<PruebaIntro />} />
          <Route path="pruebas/:id/run"    element={<ExamenRunner />} />
          <Route path="resultado"          element={<ResultadoSimple />} />
          <Route path="resultados" element={<Resultados />} />
        </Route>

        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </BrowserRouter>
  );
}
